/*
 * Example#1 $HTTP
 *
 var promise = $http({
 method:"PUT", url:"http://backend.harri.com/api/v1/login", data:{"username": "123@123.com","password": "123123"}
 }).success(function(data, status, headers, config) {

 }).error(function(data, status, headers, config) {

 });

 asyncGlobalHandler.watchPromise(promise);

 * Example#1 $HTTP
 *
 //         var deferred = $q.defer();
 //         var promise = deferred.promise;
 //
 //         asyncGlobalHandler.watchPromise(promise);
 //
 //         var deferred2 = $q.defer();
 //         var promise2 = deferred2.promise;
 //
 //         asyncGlobalHandler.watchPromise(promise2);
 //
 //         $timeout(function() {
 //             deferred.resolve("AWESOME");
 //             $timeout(function() {
 //                 deferred2.reject("NOT AWESOME2 ERROR");
 //             }, 100);
 //         }, 100);

 */
var app = angular.module('harriApp');

app.factory('asyncGlobalHandler', ["$q", "$timeout", "$log", "$filter", function ($q, $timeout, $log,$filter) {

        var async = {
            promiseList: [],

            html_object: $('<div id="loading"><i class="fa fa-spinner fa-spin"></i> &nbsp;'+$filter("translate")("Loading")+'</div>'),

            pageChangeDefer:$q.defer(),

            watchPageChange: function() {
                async.watchPageChangeFinished();

                //create a new defer
                async.pageChangeDefer = $q.defer();

                //watch it
                async.watchPromise( async.pageChangeDefer.promise );
            },
            watchPageChangeFinished: function() {
                //resolve old page
                async.pageChangeDefer.resolve();
            },

            watchPromise: function (promise, dontShowLoading, dontHandleErrors) {
//                show loading
                async.load(promise, dontShowLoading);

                if (dontShowLoading !== true) {
                    async.promiseList.push(promise);
                }

                promise.then(function (result) {

                    //complete
                    async.resolved(result, dontShowLoading);

                }, function (reason) {

                    //rejected

                    if (dontHandleErrors === true) {
                        return;
                    }
                    async.error(reason);

                }).finally(function () {

                    //finally
                    var index = async.promiseList.indexOf(promise);
                    if (index >= 0) {
                        async.promiseList.splice(index, 1);
                    }

                    if (async.promiseList.length == 0) {
                        async.allResolved(dontShowLoading);
                    }

                });
            },

            /**
             * Watch promise dict a wrapper for watch promise
             * {
             *   'key': promise,
             *   'key2':..
             * }
             * @param promisesDict
             * @param dontShowLoading
             * @param dontHandleErrors
             */
            watchPromiseDict: function (promisesDict, dontShowLoading, dontHandleErrors) {
                var promiseKey, promise;
                for (promiseKey in promisesDict) {
                    promise = promisesDict[promiseKey];
                    this.watchPromise(promise, dontShowLoading, dontHandleErrors);
                }
            },

            load: function (promise, dontShowLoading) {
                //@TODO show loading


//                $('html').append(async.html_object);
//                async.html_object.show().attr("id", "loading");


            },
            allResolved: function (dontShowLoading) {
                //@TODO hide loading item from screen.
                // $('#loading').remove();
//                async.html_object.hide();

            },
            resolved: function (msg, dontShowLoading) {

            },
            error: function (msg) {
                $log.error("error", "asyncGlobalHandler", msg);
                //@TODO show error on screen
            }

        };
        return async;
    }]
);

/**
 * Retry Ajax Call
 *
 */
app.factory('RetryCall', ["$q", "$injector", "$timeout", "$filter", "InternetConnectionChecker", function ($q, $injector, $timeout,$filter,InternetConnectionChecker) {
    var RetryCall = {
        // counter memory
        'memo': {},

        // timeout
        'timeOut':500,

        // failed requests queue
        'failedRequests': [],

        // when API's fail skip this list
        'skipUrls':['unread_message_count_employer', 'unread_message_count_candidate', 'message_baord_data','translate_language',
                    'application_message_counts', 'employer_applications', 'candidate_applications'],

        // process failed function
        'processFailed': function () {
            while (RetryCall.failedRequests.length != 0) {
                var func = RetryCall.failedRequests.pop();
                func();
            }
        },

        // maximum number of retry
        'MAX_NUMBER_OF_RETRY': 5,

        // optional method
        'request': function (config) {

            // do something on success
            return config;
        },

        // optional method
        'requestError': function (rejection) {
            return $q.reject(rejection);
        },


        // optional method
        'response': function (response) {
            // do something on success
            /**
             * Remove no internet connection popup if exist
             */
            if( response.status != 0 ){
              InternetConnectionChecker.becomeOnline();
            }

            return response;
        },

        // optional method
        'responseError': function (rejection) {

            var hasSkipURL = false,linkRegex;
            for( var i=0; i<RetryCall.skipUrls.length; i++){


                linkRegex = new RegExp(RetryCall.skipUrls[i]);
                if( linkRegex.test(   rejection.config.url) ){
                    hasSkipURL=true;
                    break;
                }

            }

            if( !hasSkipURL ){
                return RetryCall.retry(rejection);
            }

        },

        /*
            Retry Function
            when we made new request:
                if the url not exists or less than maximum number:
                    - create list of promises
                    - push them to failedRequests queue
                    - call processFailed on timeout
                    - return promise
                else:
                    - show refresh page button
                    - reject the promise
         */
        'retry': function (rejection) {

            if (rejection.config && (
                !RetryCall.memo[ rejection.config.url ] ||
                RetryCall.memo[ rejection.config.url ] < RetryCall.MAX_NUMBER_OF_RETRY)
            ){

                var deferred = $q.defer();
                RetryCall.failedRequests.push( function(){
                    var $http = $injector.get('$http');
                   deferred.resolve($http(rejection.config));
                });

                var numberOfFailedRequests = RetryCall.memo[ rejection.config.url ]?  RetryCall.memo[ rejection.config.url ]: 0;
                $timeout(function () {
                    RetryCall.processFailed();
                }, RetryCall.timeOut * numberOfFailedRequests);


                RetryCall.memo[ rejection.config.url ] = RetryCall.memo[ rejection.config.url ] ? ++RetryCall.memo[ rejection.config.url ] : 1;

                return deferred.promise;
            }
            else {

                hLog("ASYNC_HANDLER", "API", rejection);


                /**
                 * validate the rejection if it occurred by the loosing internet
                 */
                InternetConnectionChecker
                  .checkConnection()
                  .then(function( isConnectionExist ){
                    if( isConnectionExist ){
                      $(".fatal-page-error").remove();
                      $('<div class="fatal-page-error">'+$filter("translate")("Oops..!, something wrong happened,")+' <a href="#" onclick="hRedirect(window.location.href)">'+$filter("translate")("click here")+'</a> ' +
                      $filter("translate")("to refresh the page and try again.")+'</div>').appendTo('body');
                    }
                  });


                delete RetryCall.memo[ rejection.config.url ];
                return $q.reject(rejection);
            }
        }
    };

    return RetryCall;
}]);

app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('RetryCall');

    $httpProvider.interceptors.push(["$q", function ($q) {
        return {
            request: function (config) {
                var deferred = $q.defer();

                if (['GET', 'HEAD', 'OPTIONS', 'TRACE'].indexOf(config.method) < 0) {
                    var csrfToken = HStorageManager.get({
                        key: "csrftoken",
                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                        codec: false
                    });
                    config.headers['X-CSRFToken'] = csrfToken && decodeURI(csrfToken);
                    // This is a workaround to overcome the problem of the logged out users on the old frontend code who didn't refresh their broswer,
                    // please come here later on and remove this shit
                    // My manager Feras Kayali has approved this shit. If you want to contact him here is his phone number:
                    // 0595316248
                    config.headers['FORCE-CSRF'] = true;
                }

                if (config.url.includes('gateway.harri')) {
                    hLoginManager.getToken()
                        .then(function (_token) {
                            if (_token) {
                                config.headers['Authorization'] = 'Bearer ' + _token;
                            }
                        })
                        .finally(function () {
                            deferred.resolve(config);
                        });
                } else {
                    deferred.resolve(config);
                }

                return deferred.promise;
            }
        };
    }]);
}]);

/**
 * Service to work with Internet Connection
 */
app.factory('InternetConnectionChecker', ['$window','$rootScope',function($window,$rootScope){

  var checkerInterface =  {

    /**
     * Browser Level Listner
     */
    'initBrowserListeners' : function(){

      if( $window.addEventListener ){
        $window.addEventListener('online', function(){ checkerInterface.becomeOnline() } , false);
        $window.addEventListener('offline', function(){ checkerInterface.becomeOffline() } , false);
      }
      else{
        document.body.ononline = checkerInterface.becomeOnline;
        document.body.onoffline = checkerInterface.becomeOffline;
      }

    },
    /**
     * Init Caller
     */
    'init' : function(){
      this.initBrowserListeners();
    },
    /**
     * User become online after connection lost
     */
    'becomeOnline' : function(){
      if( $('.connection-lost').length ){
        $rootScope.$broadcast('InternetOnline');
        $('.connection-lost').remove();
      }
    },
    /**
     * User connection lost
     */
    'becomeOffline' : function(){
      if( $('.connection-lost').length == 0 ){
        $rootScope.$broadcast('InternetOffline');
        $('<div class="fatal-page-error connection-lost">'+'<i class="fa fa-spinner fa-spin"></i>&nbsp;'+$filter("translate")("No internet connection, connecting...")+'</div>').appendTo('body');
      }
    },
    /**
     * Check if user connection exist
     * @returns {*}
     */
    'checkConnection' : function(){
      var defer = $q.defer();

      $http({
        'method' : 'GET',
        'url' : 'https://d2cif42w8ibknl.cloudfront.net/status.json',
        'cache' : false
        })
        .then(function(){
          checkerInterface.becomeOnline();
          defer.resolve(true);
        })
        .catch(function(){
          checkerInterface.becomeOffline();
          defer.resolve(false);
        });

      return defer.promise;
    }
  }

  return checkerInterface;

}]);

/**
 * Init InternetConnectionChecker service
 */
app.run(['InternetConnectionChecker',function(InternetConnectionChecker){
  InternetConnectionChecker.init();
}]);
